<template>
  <label class="toggle" ref="toggle">
    <div class="knob" ref="knob" />
    <input type="checkbox" :id="context.id" v-model="context.model" />
  </label>
</template>

<script>
import anime from 'animejs'
export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.setInitialPosition(this.context.model)
  },
  watch: {
    'context.model'(status) {
      this.animate(status)
    }
  },
  methods: {
    animate(status) {
      const knob = this.$refs.knob
      const toggle = this.$refs.toggle
      const documentStyle = getComputedStyle(document.documentElement)
      const backgroundColor = documentStyle.getPropertyValue(status ? '--color-purple-1' : '--color-gray-2').trim()
      const borderColor = documentStyle.getPropertyValue(status ? '--color-purple-1' : '--color-gray-4').trim()
      const translateX = status ? knob.parentElement.offsetWidth - knob.offsetWidth - 2 : 0
      const tl = anime.timeline({ easing: 'easeInOutQuad', duration: 200 })
      tl.add({ targets: knob, translateX }, 0)
      tl.add({ targets: toggle, borderColor, backgroundColor }, 0)
      return tl
    },
    setInitialPosition(status) {
      const animation = this.animate(status)
      animation.seek(animation.duration)
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  position: relative;
  width: 3.6rem;
  height: 2.1rem;
  border: solid 1px;
  border-radius: 100px;
  box-sizing: content-box;
  cursor: pointer;
  display: block;
}
.knob {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  background: var(--color-white-1);
}
input {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px !important;
  height: 1px !important;
}
</style>
